<template>
  <div>
    <div v-if="isLoggedin == true" class="ui menu">
      <div class="ui dropdown item" v-on:click="onOpenLeftHeader">
        <img width="40" alt="Angular Logo" src="../assets/logo_response.png" />
      </div>
      <router-link class="item" to="/">
        Messages
        <div
          v-if="getMessages > 0"
          class="ui blue left pointing label"
          id="totalMessages"
        >
          {{ getMessages }}
        </div>
      </router-link>
      <div class="right menu">
        <a class="item" @click="logOut">
          <i class="logout icon"></i>
          Logout
        </a>
      </div>
    </div>

    <div id="left_Header_Menu" class="ui sidebar vertical menu">
      <div class="item">
        <a class="ui logo icon image" href="/">
          <img src />
        </a>
        <router-link to="/" v-on:click.native="closeSidebar">
          <b>ResponseQue</b>
        </router-link>
      </div>
      <router-link to="/" class="item" v-on:click.native="closeSidebar"
        >Message Queue</router-link
      >
      <div class="item">
        Manage
        <div class="menu">
          <router-link
            class="item"
            to="/qarecord"
            v-on:click.native="closeSidebar"
            >Q&A Records</router-link
          >
          <router-link to="/log" class="item" v-on:click.native="closeSidebar">
            Log
          </router-link>
          <router-link
            to="/categories"
            class="item"
            v-on:click.native="closeSidebar"
          >
            Categories
          </router-link>
          <a class="item">Quick Links</a>
          <a class="item">Forms</a>
          <router-link
            to="/agents"
            class="item"
            v-on:click.native="closeSidebar"
          >
            Agents
          </router-link>
        </div>
      </div>
      <a class="item">Report</a>
      <div class="item">
        Settings
        <div class="menu">
          <!-- <a class="active item">Configure Application</a> -->
          <a class="item">Configure Application</a>
          <a class="item">Messages</a>
          <router-link
            v-on:click.native="closeSidebar"
            class="item"
            to="/generateWidget"
            >Generate Widget</router-link
          >
          <a class="item">API</a>
        </div>
      </div>
      <router-link class="item" to="/profile" v-on:click.native="closeSidebar"
        >My Profile</router-link
      >
      <div class="item">
        Help
        <div class="menu">
          <a class="item">Live Help</a>
          <a class="item">User Guide</a>
        </div>
      </div>
      <div class="pusher">
        <!-- Site content !-->
      </div>
    </div>
  </div>
</template>
<script>
import router from "../router/index";

export default {
  name: "headervue",

  data() {
    return {
      isLoggedin: this.$store.state.loggedIn,
      dbName: ""
    };
  },
  computed: {
    getLoggedIn() {
      return this.$store.state.loggedIn;
    },
    getMessages() {
      return this.$store.getters.getMessagesCount;
    }
  },
  methods: {
    closeSidebar() {
      $("#left_Header_Menu")
        .sidebar("setting", "transition", "overlay")
        .sidebar("toggle");
    },
    onOpenLeftHeader() {
      $("#left_Header_Menu")
        .sidebar("setting", "transition", "overlay")
        .sidebar("toggle");
    },
    logIn() {
      // call action from state
      this.$store.dispatch("logIn", true);
    },
    logOut() {
      this.$store.commit("LOGIN", false);
      localStorage.clear();
      router.push("/login").catch(err => {});
    }
  },
  beforeMount() {
    this.logIn();
    this.dbName = this.$route.params.dbName;
  },
  created() {
    this.$store.watch(
      state => {
        return this.$store.state.loggedIn; // could also put a Getter here
      },
      (newValue, oldValue) => {
        // something changed do something
        // console.log(oldValue)
        // console.log(newValue)
        if (newValue == true) {
          this.isLoggedin = true;
          // router.push("/");
        } else {
          this.isLoggedin = false;
          if (this.$route.name != "Login") {
            if (this.dbName) {
              this.$router
                .push({
                  name: "Logindb",
                  params: {
                    dbName: this.dbName
                  }
                })
                .catch(err => {});
            } else {
              this.$router.push("login");
            }
          }
        }
      },
      // Optional Deep if you need it
      {
        deep: true
      }
    );
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/Header.vue